var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%"}},[_c('el-empty',{attrs:{"description":"No Data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }